import { Injectable } from "@angular/core";
import { AppGuard } from "./app.guard";
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { IamAuthService, MsalGuardFromService } from "@cemex-core/msal-services-v1";


@Injectable({
    providedIn: 'root'
  })
  export class AuthFactoryGuard implements CanActivate, CanActivateChild {
    constructor(
      private appGuard: AppGuard,
      private msalGuard: MsalGuardFromService,
      private iamService: IamAuthService
    ) {}

    canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
      const isAuthIamStarted = this.iamService.isAuthIamStarted();

      if (isAuthIamStarted) {
        const response = this.msalGuard.canActivate(route, state);
        return response;
      }
        return this.appGuard.canActivate(route, state);
    }

    canActivateChild(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
      const isAuthIamStarted = this.iamService.isAuthIamStarted();

      if (isAuthIamStarted) {
        const response = this.msalGuard.canActivate(route, state);
        return response;
      }
        return this.appGuard.canActivateChild(route, state);
    }
  }
